import { render, staticRenderFns } from "./ApRejectButton.vue?vue&type=template&id=874afa32&scoped=true&"
import script from "./ApRejectButton.vue?vue&type=script&lang=js&"
export * from "./ApRejectButton.vue?vue&type=script&lang=js&"
import style0 from "./ApRejectButton.vue?vue&type=style&index=0&id=874afa32&scoped=true&lang=css&"
import style1 from "./ApRejectButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874afa32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VDialog,VForm,VIcon,VTextarea})
